import { ChangeDetectionStrategy, Component, ComponentFactoryResolver, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DynamicComponentItem } from '../../models/dynamic-component-loader/DynamicComponentItem.model';
import { IDynamicComponent } from '../../models/dynamic-component-loader/IDynamicComponent.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddDynamicComponentDirective } from '../../directives/add-dynamic-component.directive';


export class DynamicDialogParams {
  public hideCancel: boolean = null;
  public showCloseIcon = true;
  public disableClose = false;
  public title: string = null;
  public subTitle: string = null;
  public actionLabel: string = null;
  public cancelLabel: string = null;
  public panelClass: string = null;
  public svgIcon: string = null;
  public actionButtonColor: string = 'primary';
  public dynamicComponent: DynamicComponentItem = null;
  public vcr: ViewContainerRef = null;
  public actionPosition: 'left' | 'center' | 'right' = 'left';
  public highlightText: string = null;
  public hideAction: boolean = false;
  public autoFocus: boolean = true;

  // constructor(
  //   public title: string = null,
  //   public actionLabel: string = null,
  //   public cancelLabel: string = null,
  //   public panelClass: string = null,
  //   public svgIcon: string = null,
  //   public actionButtonColor: string = 'primary',
  //   public dynamicComponent: DynamicComponentItem = null,
  //   public vcr: ViewContainerRef = null,
  //   public actionPosition: 'left' | 'center' | 'right' = 'left',
  //   public highlightText: string = null,
  //   public hideAction: boolean = false
  // ) {
  // }
}


@Component({
  selector: 'terra-dynamic-dialog',
  templateUrl: './dynamic-dialog.component.html',
  styleUrls: ['./dynamic-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynamicDialogComponent implements OnInit {
  // for dynamic component loader
  @ViewChild(AddDynamicComponentDirective, { static: true }) terraAddDynamicComponent!: AddDynamicComponentDirective;

  constructor(
    public dialogRef: MatDialogRef<DynamicDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DynamicDialogParams,
    private componentFactoryResolver: ComponentFactoryResolver) {
  }

  ngOnInit() {
    if (this.data.dynamicComponent) {
      this.loadComponent();
    }

    if (this.data.panelClass) {
      this.dialogRef.addPanelClass(this.data.panelClass);
    }
  }

  // for dynamic component loader
  loadComponent() {
    const viewContainerRef = this.terraAddDynamicComponent.viewContainerRef;
    viewContainerRef.clear();
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.data.dynamicComponent.component);
    const componentRef = viewContainerRef.createComponent<IDynamicComponent>(componentFactory);
    componentRef.instance.data = this.data.dynamicComponent.data;
  }

  action() {
    this.dialogRef.close(true);
  }
}
